







import Vue, {PropType} from 'vue'

export default Vue.extend({
    props: {
        edition: {type: String},
        number: {type: String},
        tag: {type: String},
        logo: {default: true},
        app: {default: true}
    },
    computed: {
        text(): string {
            let {edition, number, tag} = this
            let text = ''
            text += `${this.app ? 'Rundeck ' : ''}`
            text += `${edition ? edition + ' ' : ''}` 
            text += `${number}`
            return text
        }
    }
})
